import { render } from "./cancelled-court.vue?vue&type=template&id=19969e8e"
import script from "./cancelled-court.vue?vue&type=script&lang=js"
export * from "./cancelled-court.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__